import axios, { AxiosResponse } from 'axios';

import { ServerData } from '@/@types/base';
import { ApiCalendarPayload, ApiCalendarData } from '@/@types/calendar';

export async function getMoonCalendar(
  query: ApiCalendarPayload
): Promise<ApiCalendarData[]> {
  const response: AxiosResponse<ServerData<ApiCalendarData[]>> = await axios({
    method: 'GET',
    url: '/moon-calendar',
    params: { ...query },
  });

  const {
    data: { success, data: datesList },
  } = response;

  if (!success) {
    throw new Error('api getMoonCalendar success false');
  }

  return datesList;
}
